<app-accordion [label]="sectionLabel" [expanded]="isExpanded()" (expandedChange)="onExpandedChange($event)">
	@if (template()?.length) {
		<div class="flex flex-col p-3">
			@for (row of template(); track row[0]?.value; let even = $even) {
				<div class="flex h-8 items-center justify-between gap-2.5 rounded-lg px-2.5" [class.bg-gray-050]="even">
					<span class="text-xs text-gray-600">{{ row[0]?.label }}</span>
					<span
						class="flex items-center gap-1 text-end text-3.25 font-medium text-gray-900"
						[dir]="row[0]?.dir">
						<span>{{ getAttributeValue(row, 0) }}</span>
						@if (isClosingPriceRow(row)) {
							<span
								class="whitespace-nowrap"
								[class.text-green-500]="(symbolData().closingPriceChangePercent ?? 0) >= 0"
								[class.text-red-500]="(symbolData().closingPriceChangePercent ?? 0) < 0">
								<ui-number
									format="1.0-0"
									dir="ltr"
									[value]="symbolData().closingPriceChange ?? 0" />&ngsp;<span
									[class.text-gray-900]="closingPriceUnchanged()"
									>(<ui-number
										dir="ltr"
										[value]="symbolData().closingPriceChangePercent ?? 0"
										[maxDigit]="2" />%)</span
								>
							</span>
						}
					</span>
				</div>
			}
		</div>
	} @else {
		<div class="flex flex-col items-center justify-center gap-2 px-3 py-6 text-gray-600">
			<ui-icon width="48" height="48" class="text-gray-600" iconName="info-box" />
			<span class="text-xs">اطلاعاتی برای نمایش وجود ندارد</span>
		</div>
	}
</app-accordion>
